import { ArrowRight, PlayCircle } from "lucide-react";
import { MEDIA } from "../mock";

export const Hero = ({ onPrimary, onSecondary }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden min-h-[100vh] flex items-end pb-20 pt-32 grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={MEDIA.hero}
          alt="OmniLink aviation command"
          className="w-full h-full object-cover object-center"
        />
        {/* Heavy gradient overlay for editorial left-align */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#050814]/95 via-[#050814]/75 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050814] via-transparent to-[#050814]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-2 w-2 bg-[#C19A5D] pulse-dot rounded-full" />
            <span className="overline">Aviation Management Platform</span>
          </div>

          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[0.95] tracking-tight">
            Absolute command
            <br />
            over your <span className="gold-text">fleet.</span>
          </h1>

          <p className="mt-8 text-lg sm:text-xl text-white/70 font-body max-w-2xl leading-relaxed">
            OmniLink unifies Office, FDC, Cabin Crew and Department Teams into a single
            aviation-grade operating system — every action attributable, every record on a
            tamper-evident audit trail.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={onPrimary}
              className="group flex items-center justify-center gap-3 bg-[#C19A5D] text-[#050814] hover:bg-[#D4AF74] transition-all duration-300 px-8 py-4 font-semibold uppercase tracking-wider text-sm"
            >
              Request Demo
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={2} />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={onSecondary}
              className="group flex items-center justify-center gap-3 bg-transparent text-white border border-white/20 hover:bg-white/5 hover:border-white/40 transition-all duration-300 px-8 py-4 font-semibold uppercase tracking-wider text-sm"
            >
              <PlayCircle className="h-4 w-4" strokeWidth={1.5} />
              Explore Platform
            </button>
          </div>

          {/* Metrics strip */}
          <div className="mt-20 grid grid-cols-2 sm:grid-cols-4 gap-8 max-w-2xl">
            {[
              { v: "5", l: "Command tiers" },
              { v: "Unlimited", l: "Aircraft & teams" },
              { v: "Immutable", l: "Audit trail" },
              { v: "Role-based", l: "Permissions" },
            ].map((m, i) => (
              <div key={i} data-testid={`hero-metric-${i}`} className="border-l border-[#C19A5D]/40 pl-4">
                <div className="font-heading text-2xl sm:text-3xl text-white">{m.v}</div>
                <div className="text-xs text-white/50 uppercase tracking-wider mt-1">{m.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
